<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Reporte General</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button class="btn-info" type="button" @click="consultar(false)">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
          <button class="btn-success" type="button" @click="exportar">
            <i class="fa fa-file-excel-o"></i>
            <span>Exportar</span>
          </button>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-3" style="white-space: nowrap;">
            <div class="select2-field select2-field--stretch">
              <v-select id="plantilla" label="descripcion" v-model="selectedPlantilla" :options="plantillas"
                @input="inputPlantilla"></v-select>
              <label for="plantilla">Tipo reporte</label>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="select2-field select2-field--stretch">
              <v-select id="yard" v-model="form.yard_code" multiple @input="inputYard" :options="patios"></v-select>
              <label for="yard">Yard</label>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="select2-field select2-field--stretch">
              <v-select id="status" label="name" v-model="selectedStatus" multiple :options="estados" @input="inputStatus">
              </v-select>
              <label for="status">Status</label>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="select2-field select2-field--stretch">
              <v-select id="customer" label="name" v-model="selectedCustomer" multiple :options="customers"
                @input="inputCustomer"></v-select>
              <label for="customer">Customers</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-3">
            <div class="select2-field select2-field--stretch">
              <v-select id="type" label="descripcion" v-model="selectedType" :options="types" @input="inputType">
              </v-select>
              <label for="type">Type</label>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="form-field select">
              <div class="select-field">
                <select v-model="form.tipo_fecha" name="tipo_fecha" id="tipo_fecha">
                  <option value="T">Todas</option>
                  <option value="H">Hoy</option>
                  <option value="A">Ayer</option>
                  <option value="P">Personalizada</option>
                </select>
                <label for="tipo_fecha">Tipo de fecha</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-2">
            <div class="form-field">
              <div class="datepicker-field datepicker-field--stretch">
                <date-picker @enterkey="consultar" v-model="form.desde" type="date" id="desde"></date-picker>
                <label for="desde">Desde</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-2">
            <div class="form-field">
              <div class="datepicker-field datepicker-field--stretch">
                <date-picker @enterkey="consultar" v-model="form.hasta" type="date" id="hasta"></date-picker>
                <label for="hasta">Hasta</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-2">
            <div class="select2-field select2-field--stretch">
              <v-select id="tipo" label="descripcion" v-model="selectedTipo" :options="tipos" @input="inputTipo">
              </v-select>
              <!-- <label for="tipo">Tipo</label> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <details class="card card--collapsible mt-3 mb-3">
      <summary class="card__title card__title--bg-primary">
        <div class="form-inline">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <h5>Datos a mostrar</h5>
        </div>
      </summary>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12" style="max-height: 280px; height: auto; overflow-y: scroll">
            <checked-listbox @input="inputColumna" :items="columnas" :columns="4" name="columnas[]"
              v-model="form.columnas" field="nombre"></checked-listbox>
          </div>
        </div>
      </div>
    </details>
    <details class="card card--collapsible mt-3 mb-3" open>
      <summary class="card__title card__title--bg-primary">
        <div class="form-inline">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <h5>Resultados</h5>
        </div>
      </summary>
      <div class="card__content" style="height: auto;">
        <dynamic-table colorTd colorTh :columnasInvisibles="form.columnasInvisibles" :columnas="columns" :registros="registros"
          :totalItems="totalItems" :currentPage="form.currentPage" :registrosPorPagina="form.registrosPorPagina"
          :mostrarSelectedMultiple="true" :mostrarRegistrosTotales="true" :columnasCheck="columnasCheck"
          :columnasBox="columnasBox" :columnasMac="columnasMac" ref="table"
          @handleSort="handleSort" @handleChangePage="handleChangePage" @filtrarBusqueda="filtrarBusqueda"
          @seleccionado="rowSeleccionado" @handleSelected="handleSelected">
        </dynamic-table>
        <div v-show="registros.length !== 0" class="col-md-12 form-inline">
          <div>
            <p>Amount.B (p): {{ pag_a_b }}</p>
          </div>
          <div>
            <p>Amount.B (t): {{ total_a_b }}</p>
          </div>
          <div>
            <p>MH.B (p): {{ pag_mh_b }}</p>
          </div>
          <div>
            <p>MH.B (t): {{ total_mh_b }}</p>
          </div>
          <div>
            <p>Amount.M (p): {{ pag_a_m }}</p>
          </div>
          <div>
            <p>Amount.M (t): {{ total_a_m }}</p>
          </div>
          <div>
            <p>MH.M (p): {{ pag_mh_m }}</p>
          </div>
          <div>
            <p>MH.M (t): {{ total_mh_m }}</p>
          </div>
        </div>
      </div>
    </details>
    <modal :clickToClose="false" width="75%" height="auto" scrollable name="editarPropiedades">
      <editar-unidad soloEdicion :historico="currentSecuencia == '' ? false : true" :numeroContenedor="currentNumber"
        :numeroSecuencia="currentSecuencia" 
        :puede_editar_gate_in="puede_editar_gate_in"
        :puede_editar_gate_out="puede_editar_gate_out"
        :puede_editar_in="puede_editar_in"
        :puede_editar_out="puede_editar_out"
        :puede_editar_caja="puede_editar_caja"
        :puede_editar_maquina="puede_editar_maquina"
        :puede_enviar_edi_in="puede_enviar_edi_in"
        :puede_enviar_edi_out="puede_enviar_edi_out"
        @cerrarUnidad="cerrarUnidad"
        @eliminarUnidad="eliminarUnidad" v-model="currentUnidad" :puede_editar_status="puede_editar_status"
        :puede_eliminar="puede_eliminar"
        ref="editarUnidad"
      >
      </editar-unidad>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    patios: {
      type: Array,
      required: false,
      default: () => [],
    },
    estados: {
      type: Array,
      required: false,
      default: () => [],
    },
    customers: {
      type: Array,
      required: false,
      default: () => [],
    },
    types: {
      type: Array,
      required: false,
      default: () => [],
    },
    plantillas: {
      type: Array,
      required: false,
      default: () => [],
    },
    editar_status: {
      type: Boolean,
      required: false,
      default: false
    },
    eliminar: {
      type: Boolean,
      required: false,
      default: false
    },
    editar_status_historico: {
      type: Boolean,
      required: false,
      default: false
    },
    eliminar_historico: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_gate_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_gate_out: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_out: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_caja: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_maquina: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_enviar_edi_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_enviar_edi_out: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      patioDefault: patioDefault,
      tipos: [
        {
          'value': 'gate_in_date',
          'descripcion': 'IN'
        },
        {
          'value': 'gate_out_date',
          'descripcion': 'OUT'
        },
        {
          'value': 'inOut',
          'descripcion': 'IN/OUT'
        },
        {
          'value': 'date_i_m',
          'descripcion': 'Inspection M'
        },
        {
          'value': 'date_r_m',
          'descripcion': 'Repaired M'
        },
        {
          'value': 'date_f_m',
          'descripcion': 'Invoiced M'
        },
        {
          'value': 'date_i_b',
          'descripcion': 'Inspection B'
        },
        {
          'value': 'repaired_date',
          'descripcion': 'Repaired B'
        },
        {
          'value': 'date_f_b',
          'descripcion': 'Invoiced B'
        }
      ],
      selectedCustomer: [],
      selectedStatus: [],
      selectedType: null,
      selectedPlantilla: null,
      selectedTipo: null,
      form: {
        tipo: '',
        tipo_fecha: 'P',
        desde: moment(new Date()).subtract(7, 'd').format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        yard_code: ['Todos'],
        plantilla_code: "",
        status_codes: null,
        customer_codes: null,
        type_code: null,
        columnas: [{}],
        currentPage: 1,
        currentSearch: null,
        filtrosSearch: [],
        exportar: false,
        registrosPorPagina: 100,
        sort: null,
        key_sort: null,
        columnasConstantes: ['number', 'secuencia', 'gate_in_date','eir_out', 'aprobado_m', 'aprobado_b', 'repaired', 'repaired_m', 'man_hour_box', 'amount_b', 'man_hour_mac', 'amount_m'],
        columnasInvisibles: [],
        columnasDate: ['gate_in_date', 'gate_out_date', 'date_i_b', 'date_e_b', 'repaired_date', 'date_f_b', 'date_a_b', 'date_i_m', 'date_e_m', 'date_r_m', 'date_f_m', 'date_a_m', 'in_service'],
        isCampoNull: false
      },
      path: url + "/reporte/consulta/general",
      columnas: [],
      columns: [],
      registros: [],
      columnasBox: [
        'inspection_b', 'date_i_b', 'estimado_b', 'date_e_b', 'repaired', 'repaired_date', 'amount_b', 'invoiced_box', 
        'date_f_b', 'aprobado_b', 'date_a_b', 'man_hour_box', 'test_on_remark'
      ],
      columnasMac: [ 
        'inspection_m', 'date_i_m', 'estimado_m', 'date_e_m', 'repaired_m', 'date_r_m', 'amount_m', 'invoiced_machine', 
        'date_f_m', 'aprobado_m', 'date_a_m', 'man_hour_mac', 'spare_parts'
      ],
      totalItems: 1,
      // Totales de la consulta
      total_mh_b: 0,
      total_a_b: 0,
      total_mh_m: 0,
      total_a_m: 0,
      // Totales por página
      pag_mh_b: 0,
      pag_a_b: 0,
      pag_mh_m: 0,
      pag_a_m: 0,

      id: 0,
      columnasCheck: [
        'inspection_b',
        'estimado_b',
        'repaired',
        'invoiced_box',
        'aprobado_b',
        'inspection_m',
        'estimado_m',
        'repaired_m',
        'invoiced_machine',
        'aprobado_m',
        'dispatched',
        'dispatched_out'
      ],
      currentUnidad: null,
      currentNumber: null,
      currentSecuencia: '',
      puede_editar_status: false,
      puede_eliminar: false
    };
  },
  methods: {
    consultar: function (changePage = false) {
      const that = this;
      that.form.currentSearch = "";
      that.form.isCampoNull = false;
      this.$refs.table.limpiar();
      that.form.filtrosSearch.splice(0, that.form.filtrosSearch.length);
      if (that.form.plantilla_code === "" || that.form.plantilla_code === null) {
        swal(
          "Debe seleccionar una plantilla.",
          "Aviso",
          "warning"
        );
        return;
      }
      that.columns.splice(0, that.columns.length);
      that.form.columnasInvisibles.splice(0, that.form.columnasInvisibles.length);
      if (!that.form.columnas.includes('gate_in_date'))
        that.form.columnasInvisibles.push('days');
      that.llenarColumnasInvisibles();

      axios
        .get(that.path, {
          params: that.form
        })
        .then(function ({ data }) {
          that.totalItems = parseInt(data.totales.registros_totales);
          that.total_mh_b = parseFloat(+data.totales.mh_b).toFixed(2);
          that.total_a_b = parseFloat(+data.totales.a_b).toFixed(2);
          that.total_mh_m = parseFloat(+data.totales.mh_m).toFixed(2);
          that.total_a_m = parseFloat(+data.totales.a_m).toFixed(2);
          if (!changePage) {
            that.registros.splice(0, that.registros.length);
            that.id = 1;
            that.form.currentPage = 1;
          }
          that.columns.push({
            descripcion: 'ID',
            value: 'id'
          });
          for (let i = 0; i < data.columnas.length; i++) {
            if (data.columnas[i].nombre === 'gate_in_date')
              that.columns.push({
                descripcion: 'Days',
                value: 'days'
              });
            that.columns.push({
              descripcion: data.columnas[i].descripcion,
              value: data.columnas[i].nombre
            });
          }
          that.llenarRegistros(data.registros);
        })
        .catch(function (error) {
          swal("Hubo un error al cargar." + error, "Error", "error");
        });

    },
    exportar: function () {
      this.form.exportar = true;
      const queryString = this.serialize(this.form);
      const urlApi = this.path + queryString;
      window.open(urlApi, "_blank");
      this.form.exportar = false;
    },
    handleSort: function (sort) {
      const camposEquip= ['tara', 'gross', 'model', 'in_service'];
      const that = this;
      if (sort[0] === 'id' || camposEquip.includes(sort[0]))
        return;
      that.form.key_sort = sort[0];
      that.form.sort = sort[1];
      let oReq = new XMLHttpRequest();
      oReq.addEventListener("load", function () {
        that.form.currentPage = 1;
        that.id = 1;
        that.rellenar(that.form.currentPage);
        const parseado = JSON.parse(this.responseText);
        that.totalItems = parseInt(parseado.totales.registros_totales);
        that.total_mh_b = parseFloat(+parseado.totales.mh_b).toFixed(2);
        that.total_a_b = parseFloat(+parseado.totales.a_b).toFixed(2);
        that.total_mh_m = parseFloat(+parseado.totales.mh_m).toFixed(2);
        that.total_a_m = parseFloat(+parseado.totales.a_m).toFixed(2);
        that.llenarRegistros(parseado.registros);
        that.registros.sort((a, b) => a.id - b.id);
      });
      const queryString = that.serialize(that.form);
      let urlRequest = that.path + queryString;
      oReq.open("GET", urlRequest);
      oReq.send();
    },
    handleChangePage: function (page) {
      this.form.currentPage = page;
      const changePage = true;
      const search = false;
      this.rellenar(page);
      if ((this.form.currentSearch != null && this.form.currentSearch != "") || this.form.isCampoNull)
        this.handleSearch(this.form.currentSearch, search);
      else this.consultar(changePage);
    },
    filtrarBusqueda: function (filtros) {
      this.form.filtrosSearch.splice(0, this.form.filtrosSearch.length)
      if (!filtros.todosSelectedMultiple)
        for (let i = 0; i < filtros.selectedMultiple.length; i++) {
          this.form.filtrosSearch.push(filtros.selectedMultiple[i].value);
        }
      this.form.isCampoNull = filtros.camposNull;
    },
    handleSearch: function (searching, search = true) {
      const that = this;
      that.form.currentSearch = searching;
      let oReq = new XMLHttpRequest();
      oReq.addEventListener("load", function () {
        if (search) {
          that.form.currentPage = 1;
          that.id = 1;
        }
        that.rellenar(that.form.currentPage);
        const parseado = JSON.parse(this.responseText);
        that.totalItems = parseInt(parseado.totales.registros_totales);
        that.total_mh_b = parseFloat(+parseado.totales.mh_b).toFixed(2);
        that.total_a_b = parseFloat(+parseado.totales.a_b).toFixed(2);
        that.total_mh_m = parseFloat(+parseado.totales.mh_m).toFixed(2);
        that.total_a_m = parseFloat(+parseado.totales.a_m).toFixed(2);
        that.llenarRegistros(parseado.registros);
        that.registros.sort((a, b) => a.id - b.id);
      });
      const queryString = that.serialize(that.form);
      let urlRequest = that.path + queryString;
      oReq.open("GET", urlRequest);
      oReq.send();
    },
    isParseNumber: function (clave) {
      const numberColumns = ['amount_m', 'amount_b', 'man_hour_mac', 'man_hour_box'];
      return numberColumns.includes(clave);
    },
    llenarRegistros: function (data) {
      const that = this;
      that.pag_a_b = 0;
      that.pag_mh_b = 0;
      that.pag_a_m = 0;
      that.pag_mh_m = 0;
      for (let i = 0; i < data.length; i++) {
        const object = {};
        that.pag_a_b = ((+that.pag_a_b) + (+data[i].amount_b)).toFixed(2);
        that.pag_mh_b = ((+that.pag_mh_b) + (+data[i].man_hour_box)).toFixed(2);
        that.pag_a_m = ((+that.pag_a_m) + (+data[i].amount_m)).toFixed(2);
        that.pag_mh_m = ((+that.pag_mh_m) + (+data[i].man_hour_mac)).toFixed(2);
        for (let j = 0; j < that.columns.length; j++) {
          if (that.columns[j].value == "id") {
            object[that.columns[j].value] = that.id;
            continue;
          }
          if (that.esFecha(that.columns[j].value)) {
            object[that.columns[j].value] = that.parseDate(that.columns[j].value, data[i][that.columns[j].value]);
            continue;
          }
          if (that.columns[j].value === "status") {
            object[that.columns[j].value] = data[i]['status_name'];
            continue;
          }
          if (that.columns[j].value === "type") {
            object[that.columns[j].value] = data[i]['type_name'];
            continue;
          }
          if (that.columns[j].value === "cy_sd_in") {
            object[that.columns[j].value] = that.typeValue(data[i][that.columns[j].value]);
            continue;
          }
          if (that.isParseNumber(that.columns[j].value)) {
            const number = data[i][that.columns[j].value];
            object[that.columns[j].value] = number === null ? null : parseFloat(number).toFixed(2);
            continue;
          }
          object[that.columns[j].value] = data[i][that.columns[j].value];
        }
        that.registros.push(object);
        that.id++;
      }
    },
    rellenar: function (page) {
      this.registros.splice(0, this.registros.length);
      this.id = 1;
      if (page != 1) {
        const relleno = (page * this.form.registrosPorPagina) - this.form.registrosPorPagina;
        for (let i = 0; i < relleno; i++) {
          const aux = {};
          this.id++;
          this.registros.push(aux);
        }
      }
    },
    llenarColumnasInvisibles: function () {
      this.form.columnasConstantes.map(columna => {
        if (!this.form.columnas.includes(columna))
          this.form.columnasInvisibles.push(columna);
      });
    },
    esFecha: function (campo) {
      return this.form.columnasDate.includes(campo);
    },
    parseDate: function (campo, value) {
      const fechaHora = ['gate_in_date', 'gate_out_date', 'in_service'];
      let format = "";
      if (value == null || value === '')
        return '';
      if (fechaHora.includes(campo))
        format = "YYYY-MM-DD HH:mm";
      else {
        format = "YYYY-MM-DD";
        value = moment(new Date(value)).format(format) + ' 00:00:00';
      }
      return moment(new Date(value)).format(format);
    },
    rowSeleccionado: function (row) {
      this.currentNumber = row.number;
      this.currentSecuencia = row.secuencia || '';
      if (this.currentSecuencia == '') {
        this.puede_editar_status = this.editar_status;
        this.puede_eliminar = this.eliminar;
      }
      else {
        this.puede_editar_status = this.editar_status_historico;
        this.puede_eliminar = this.eliminar_historico;
      }
      this.$modal.show("editarPropiedades");
    },
    handleSelected: function () {
      setTimeout(() => {
        const selection = window.getSelection();
        const txt = document.querySelector('.is-selected .number');
        const range = document.createRange();
        range.selectNodeContents(txt);
        selection.removeAllRanges();
        selection.addRange(range); 
        document.execCommand("copy");  
      }, 100);
    },
    cerrarUnidad: function () {
      this.quitarShorcutUnidad();
      this.$modal.hide('editarPropiedades');
    },
    eliminarUnidad: function () {
      this.quitarShorcutUnidad();
      this.$modal.hide('editarPropiedades');
      this.consultar();
    },
    quitarShorcutUnidad: function () {
      document.removeEventListener("keydown", this.$refs.editarUnidad.pressed);
    },

    inputYard: function () {
      if (this.form.yard_code.length > 1 && this.form.yard_code.includes('Todos') ) {
        this.form.yard_code = this.form.yard_code.filter( yard_code => yard_code != 'Todos');
      }
    },
    inputCustomer: function () {
      if (this.selectedCustomer.length != 0) {
        if (this.selectedCustomer.length > 1 && this.selectedCustomer.find( customer => customer.code === 'all') ) {
          this.selectedCustomer = this.selectedCustomer.filter( customer => customer.code != 'all');
        }
        this.form.customer_codes = this.selectedCustomer.map( customer => customer.code);
      }
      else this.form.customer_codes = [];
    },
    inputStatus: function () {
      if (this.selectedStatus.length != 0) {
        if (this.selectedStatus.length > 1 && this.selectedStatus.find( status => status.code === 'all') ) {
          this.selectedStatus = this.selectedStatus.filter( status => status.code != 'all');
        }
        this.form.status_codes = this.selectedStatus.map( status => status.code);
      }
      else this.form.status_codes = [];
    },
    inputType: function () {
      if (this.selectedType != null)
        this.form.type_code = this.selectedType.code;
      else this.form.type_code = "";
    },
    inputTipo: function () {
      if (this.selectedTipo != null)
        this.form.tipo = this.selectedTipo.value;
      else this.form.tipo = "";
    },
    inputColumna: function (value) {
      this.form.columnas = value;
    },
    inputPlantilla: function () {
      if (this.selectedPlantilla != null) {
        this.form.plantilla_code = this.selectedPlantilla.codigo;
        this.cargarCampos();
      }
      else {
        this.form.plantilla_code = "";
        this.columnas = [];
        this.form.columnas = [{}];
      }
    },
    selectDefault: function () {
      this.selectedCustomer.push(this.customers[0]);
      this.selectedStatus.push(this.estados[0]);
      this.selectedType = this.types[0];
      this.selectedTipo = this.tipos[0];
      this.inputCustomer();
      this.inputStatus();
      this.inputType();
      this.inputTipo();
    },
    typeValue: function (type) {
      const obtenerNombre = {
        CY: 'PTO',
        CF: 'DEV',
        SD: 'CCL',
        PO: 'POS',
        AC: 'ACC'
      }
      return obtenerNombre[type] || '';
    },
    cargarCampos: function () {
      const that = this;
      axios
        .get(url + "/reporte/campos/" + that.form.plantilla_code)
        .then(function ({ data }) {
          that.columnas = data.todos_campos;
          that.form.columnas = data.campos_default;
        })
        .catch(function () {
          swal("Hubo un error al cargar.", "Error", "error");
        });
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    pressed: function (e) {
      if (e.altKey && e.code === "Enter"){
        e.preventDefault();
        this.consultar();
      }
      if (e.altKey && e.code === "KeyE"){
        e.preventDefault();
        this.exportar();
      }
    }
  },
  mounted: function () {
    if (this.patioDefault != '' && this.patioDefault != null) {
      this.form.yard_code.splice(0, this.form.yard_code.length);
      for (let i = 0; i < this.patios.length; i++) {
        if (this.patioDefault == this.patios[i]) {
          this.form.yard_code.push(this.patios[i]);
          this.inputYard();
        }
      }
    }
    this.selectDefault();
    const inputSearch = document.querySelector("input.input-search");
    inputSearch.addEventListener("keyup", (e) => {
      if (e.keyCode === 13) {
        this.handleSearch(inputSearch.value);
      }
    });
    if (this.plantillas.length != 0) {
      this.selectedPlantilla = this.plantillas[0];
      this.form.plantilla_code = this.selectedPlantilla.codigo;
      this.cargarCampos();
    }
    document.addEventListener("keydown", this.pressed);
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/reportes/ReporteGeneral.vue